module.exports = __webpack_public_path__ + "img/header-logo.37b74e5.png";